export default {
  ERROR: '@k-share/auth/ERROR',
  LOGIN_REQUEST: '@k-share/auth/LOGIN_REQUEST',
  LOGIN_OK: '@k-share/auth/LOGIN_OK',
  LOGIN_CHECK: '@k-share/auth/LOGIN_CHECK',
  AUTH_OK: '@k-share/auth/AUTH_OK',
};
